import React from 'react';
import { motion } from 'framer-motion';

const containerVariants = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.06, delayChildren: 0.04 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 14 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.35, ease: [0.25, 0.46, 0.45, 0.94] },
  },
};

export function StaggerContainer({ children, className = '', as = 'div' }) {
  const Component = motion[as] || motion.div;
  return (
    <Component
      variants={containerVariants}
      initial="hidden"
      animate="show"
      className={className}
    >
      {children}
    </Component>
  );
}

export function StaggerItem({ children, className = '', as = 'div' }) {
  const Component = motion[as] || motion.div;
  return (
    <Component variants={itemVariants} className={className}>
      {children}
    </Component>
  );
}
